export type GuideOption = { id: string; label: string; department?: string }

export const DEPARTMENT_OPTIONS: GuideOption[] = [
  { id: 'sales', label: 'Sales' },
  { id: 'inventory', label: 'Inventory' },
  { id: 'shipping', label: 'Shipping & Repairs' },
]

export const WATCH_OPTIONS: GuideOption[] = [
  { id: 'trucks-sold', label: 'Trucks sold', department: 'sales' },
  { id: 'pending-sales', label: 'Pending sales', department: 'sales' },
  { id: 'leads', label: 'Leads', department: 'sales' },
  { id: 'offers', label: 'Financing offers', department: 'sales' },
  { id: 'deal-approval', label: 'Deal approval', department: 'sales' },
  { id: 'quotes', label: 'Quotes', department: 'sales' },
  { id: 'trucks-added', label: 'Trucks added', department: 'inventory' },
  { id: 'status-changes', label: 'Status changes', department: 'inventory' },
  { id: 'available', label: 'Available inventory', department: 'inventory' },
  { id: 'pricing', label: 'List prices', department: 'inventory' },
  { id: 'aging', label: 'Aging inventory', department: 'inventory' },
  { id: 'photos', label: 'Missing photos', department: 'inventory' },
  { id: 'repairs', label: 'Repairs and estimates', department: 'shipping' },
  { id: 'transport', label: 'Shipping and transport', department: 'shipping' },
  { id: 'warranty', label: 'Warranty', department: 'shipping' },
  { id: 'location', label: 'Where the truck is', department: 'shipping' },
]

export const TONE_OPTIONS: GuideOption[] = [
  { id: 'direct', label: 'Direct' },
  { id: 'brief', label: 'Brief' },
  { id: 'formal', label: 'Formal' },
  { id: 'conversational', label: 'Conversational' },
  { id: 'operational', label: 'Operational' },
]

export function watchOptionsForDepartments(departments: string): GuideOption[] {
  if (!departments || departments === 'all') return WATCH_OPTIONS
  const selected = new Set(departments.split(',').filter(Boolean))
  return WATCH_OPTIONS.filter(option => option.department && selected.has(option.department))
}

export function choiceIds(value: string): string[] {
  if (!value || value === 'all') return []
  return value.split(',').map(id => id.trim()).filter(Boolean)
}

export function isAllSelected(value: string): boolean {
  return !value || value === 'all'
}

/** All stays on until a specific category is chosen. Clearing the last category returns to All. */
export function toggleAllChoice(current: string, id: string, optionIds: string[]): string {
  if (id === 'all') return 'all'
  const selected = new Set(isAllSelected(current) ? [] : choiceIds(current))
  if (selected.has(id)) selected.delete(id)
  else selected.add(id)
  const known = optionIds.filter(optionId => selected.has(optionId))
  if (known.length === 0 || known.length === optionIds.length) return 'all'
  return known.join(',')
}
